"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseButton = _interopRequireDefault(require("./BaseButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Button = _styledComponents.default.button.withConfig({
  displayName: "IconButton__Button",
  componentId: "design-system__sc-1bzu5hm-0"
})(["", ";display:inline-flex;align-items:center;height:auto;padding:", ";svg{transform:rotate(", "deg);}& > div{display:inline-flex;max-width:unset;max-height:unset;}&.disabled{border-color:rgba(0,0,0,0.1);svg{path{fill:rgba(0,0,0,0.1);}}}"], _BaseButton.default, props => "".concat(props.iconSize / 2, "px"), props => props.iconRotate);

const IconButton = _react.default.forwardRef((_ref, ref) => {
  let {
    type,
    onClick,
    disabled,
    iconSize,
    iconRotate,
    iconProfile
  } = _ref,
      props = _objectWithoutProperties(_ref, ["type", "onClick", "disabled", "iconSize", "iconRotate", "iconProfile"]);

  return /*#__PURE__*/_react.default.createElement(Button, _extends({
    disabled: disabled,
    ref: ref,
    iconSize: iconSize,
    iconRotate: iconRotate,
    onClick: onClick,
    className: disabled ? 'disabled' : ''
  }, props), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: type,
    size: iconSize,
    profile: iconProfile
  }));
});

IconButton.propTypes = {
  type: _propTypes.default.string,
  iconSize: _propTypes.default.string,
  iconRotate: _propTypes.default.number,
  iconProfile: _propTypes.default.oneOf(['standard', 'selected']),
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
IconButton.defaultProps = {
  type: '',
  iconSize: '24',
  iconRotate: 0,
  iconProfile: 'standard',
  disabled: false,
  onClick: () => {}
};
var _default = IconButton;
exports.default = _default;